// Adapted from https://github.com/framer/motion/discussions/1884#discussioncomment-5861808
import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { animations } from "../lib/animations";

type Props = {
  children: React.ReactNode;
};

export const AnimateChangeInHeight: React.FC<Props> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [height, setHeight] = useState<number | "auto">("auto");

  useEffect(() => {
    if (containerRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        const observedHeight = entries[0].contentRect.height;
        setHeight(observedHeight);
      });

      resizeObserver.observe(containerRef.current);

      return () => {
        // Cleanup the observer when the component is unmounted
        resizeObserver.disconnect();
      };
    }
  }, []);

  return (
    <motion.div
      className={"overflow-hidden"}
      animate={{ height: height }}
      transition={animations.spring.soft}
    >
      <div ref={containerRef}>
        <div className="p-4 pb-2">{children}</div>
      </div>
    </motion.div>
  );
};
